import React from 'react';
import { Link } from 'react-router-dom';
import { Paths } from '@/routes/paths/Paths';

export const Home: React.FC = () => {
  return (
    <div style={{ fontFamily: 'sans-serif' }}>
      <h1>Components</h1>
      <h2>Account Management</h2>
      <ul>
        <li>
          <Link to={Paths.accountManager}>
            Account Management
          </Link>
        </li>
      </ul>
      <h2>Scheduling</h2>
      <ul>
        <li>
          <Link to={Paths.listScheduledContent}>
            Post Scheduling
          </Link>
        </li>
        <li>
          <Link to={Paths.createScheduledContent}>
            New Scheduling
          </Link>
        </li>
      </ul>
      <h2>Menu</h2>
      <ul>
        <li>
          <Link to={Paths.menu}>
            Menu
          </Link>
        </li>
        <li>
          <Link to={Paths.metricsMenu}>
            Metrics Menu
          </Link>
        </li>
      </ul>
      <h2>Classificação</h2>
      <ul>
        <li>
          <Link to={Paths.classification}>
            Mural de Classificação de Publicações
          </Link>
        </li>
      </ul>
      <h2>Mural de Publicações</h2>
      <ul>
        <li>
          <Link to={Paths.publicationWall}>
            Mural de Publicações
          </Link>
        </li>
        </ul>
        <h2>Resumo</h2>
        <ul>
          <li>
            <Link to={Paths.overview}>
              Visão Geral
            </Link>
          </li>
        </ul>
        <h2>Header</h2>
        <ul>
          <li>
            <Link to={Paths.header}>
              Header
            </Link>
          </li>
        <li>
          <Link to={Paths.headerMenu}>
            Header & Menu
          </Link>
        </li>
      </ul>
      <h2>Filtro Global</h2>
      <ul>
        <li>
          <Link to={Paths.globalFilter}>
            Filtro Global
          </Link>
        </li>
      </ul>
      <h2>Central</h2>
      <ul>
        <li>
          <Link to={Paths.central}>
            Central
          </Link>
        </li>
      </ul>
      <h2>New Setup</h2>
      <ul>
        <li>
          <Link to={Paths.newSetup}>
            New Setup
          </Link>
        </li>
      </ul>
    </div>
  );
};
